<template>
  <b-container fluid style="width: 100%;">
    <b-row :style="`padding-right: 2px;`">
      <b-col cols="1" style="padding-left: 0">
        <div style="padding-left: 0; padding-right: 10px">
          <font-awesome-icon class="handle" :icon="['fas', 'bars']" size="1x"/>
        </div>
      </b-col>
      <b-col cols="9">
        <ul class="nav nav-pills flex-column navbar-nav" :style="getUlStyles()" :id="listItems.name">
          <li style="getListStyle(listItems.topLevel);" :class="getClassType(sectionName)" :id="listItems.name">
            <a href="#" @click="tabClick(listItems.name, listItems)" class="ajax"
               style="font-family: 'Montserrat', sans-serif; text-transform: uppercase ">
                <span v-if="showIcon(listItems.iconValue)" style="padding-left: 10px">
                  <svgicon :icon="listItems.iconValue" :color="listItems.iconColor"
                           width="35" height="35" :original="useOriginal(listItems.iconColor)"></svgicon></span>
              <div :class="getMenuItemClass(listItems.name)" style="margin-left: 5px; ">
                {{ listItems.displayName.toUpperCase() }}
              </div>
            </a>
            <ul :class="activeClass('poo')" :style="displayType(1)" :id="listItems.name+'-subMenu'">
              <draggable
                  @start="drag=true"
                  :list="listItems.itemList"
                  style="width: 100%; margin-bottom: 5px"
                  group="coreQuestions"
                  @end="onEnd" handle=".handle">
                <li v-for="member in listItems.itemList" :key="member.id" :class="  getLineItemClass(member.name)"
                    :id="member.name">
                  <VineyardMenuItemV2Editor :section="member.name" :value="member" :key="member.id"
                                            :top-level-parent="[topParent.concat(member.name)]"/>
                </li>
              </draggable>
            </ul>
            <!--        <ul :class="activeClass('poo')" :style="displayType(1)" :id="toIdString(listItems.name)">-->
          </li>
        </ul>
      </b-col>
      <b-col cols="2" class="text-right">
        <div style="float: right; padding-top: 5px; padding-right: 0px; vertical-align: top;">
          <font-awesome-icon icon="plus-circle" size="1x" @click="expand(listItems.name)"/>
        </div>
        <div style="float: right; padding-top: 5px; padding-right: 5px; vertical-align: top;">
          <font-awesome-icon icon="minus-circle" size="1x" @click="removeMe"/>
        </div>
      </b-col>
      <b-col>

      </b-col>

    </b-row>
  </b-container>
</template>

<script>
import Bus from "../../../eventBus";
import '../../../compiled-icons';
import Draggable from "vuedraggable";

export default {
  name: 'VineyardMenuItemV2Editor',
  props: {
    value: Object,
    section: String,
    surveyKey: String,
    topLevelParent: []
  },
  component: {
    Draggable,
  },
  data() {
    return {
      listItems: this.value,
      sectionName: this.section || "poop",
      topParent: this.topLevelParent
    }
  },
  created() {
    Bus.$on('page-change', this.handlePageChange);
  },
  beforeCreate: function () {
    this.$options.components.VinieyatdMenuItemV2Editor = require('./VineyardMenuItemV2Editor.vue').default
  },
  beforeDestroy() {
    Bus.$off('page-change', this.handlePageChange);
  },
  mounted() {
    this.closeAllSubmenus();
  },
  methods: {
    handlePageChange: function (pageId) {
      console.log("Handling Page Id Change for Id: " + pageId);
      if (pageId === this.listItems.link) {
        this.highlightSection(this.listItems.name);
      }
    },
    highlightSection: function (name) {
      this.closeAllSubmenus();
      this.unhighlightAllMenuItem(name);
      this.highlightMenuItem(this.topParent[0]);
      document.getElementById(this.toIdString(name)).style.display = "initial";
      document.getElementById(this.toIdString(name)).style.backgroundColor = "red";
      document.getElementById(this.toIdString(name)).style.display = "inline";
      this.topParent.forEach(parent => {
        document.getElementById(this.toIdString(parent)).style.display = "initial";
        document.getElementById(this.toIdString(parent)).style.display = "inline";
      });
    },
    useOriginal: function (color) {
      let shouldUseOriginal = color.length === 0;
      console.log("Should use original: " + shouldUseOriginal);
      return shouldUseOriginal;
    },
    getListStyle: function (topLevel) {
      if (topLevel === true) {
        return "list-style-type: disc";
      } else {
        return "list-style-type: none";
      }
    },
    showIcon: function (iconName) {
      if (iconName) {
        return true;
      } else {
        return false;
      }
    },
    capitalize: function (str) {
      if (str.length === 0) return str;
      return str[0].toUpperCase() + str.substr(1);
    },

    titleCase: function (str) {
      //console.log("The string to Title Case: [" + str + "]");
      str = str.toLowerCase();
      return str.split(' ').map(this.capitalize).join(' ');
    },
    activeClass: function (...names) {
      for (let name of names) {
        if (name === this.$route.name)
          return 'sub-menu active';
      }
      return 'sub-menu';
    },
    getMenuItemClass: function (menuItemName) {
      console.log(`Menu Item Name: ${menuItemName}`);
      let classVal = "d-inline " + menuItemName.toLowerCase()
          .replace(',', '')
          .replace(')', '')
          .replace('/', '-')
          .replace('_', '-')
          .replace('&', 'and');
      console.log(`Menu Item Name  Converted: ${classVal}`);
      return classVal;
    },
    getProgressBarClass: function (sectionName) {
      return "progress-bar progress-background " + sectionName.toLowerCase() + "_progress";
    },
    getClassType: function (groupName) {
      console.log(`Group Name: ${groupName}`);
      return groupName.toLowerCase().replace(/_/g, "-")
          .replace(/\//g, '-')
          .replace(/,/g, '-')
          .replace(/&/g, '-') + "-group nav-item";
    },
    getLineItemClass: function (sectionName) {
      return "default-line-item";
    },
    getLineItemLinkClass: function (sectionName) {
      return "ajax " + sectionName.toLowerCase() + "-line-item";
    },
    toIdString: function (idCandidate) {
      return idCandidate.toUpperCase()
          .replace(" ", "_")
          .replace("/\//g", "_");
    },
    displayType: function (...names) {
      for (let name of names) {
        if (name === this.$route.name)
          return 'list-style-type: none; font-family: Montserrat, sans-serif; padding-right: 0px; padding-left 5px';
      }
      //return 'display: none; list-style-type: none; color: black; font-family: Montserrat, sans-serif; padding-right: 0px;';
      return 'list-style-type: none; color: black; font-family: Montserrat, sans-serif; padding-right: 0px; padding-left 5px';
    },
    triggerMessage: function (pageName) {
      document.getElementById(pageName).style.display = "initial";
    },
    closeAllSubmenus: function () {
      let submenus = document.querySelectorAll(".sub-menu");
      submenus.forEach(val => {
        val.style.display = "none";
      });
    },
    highlightMenuItem: function (section) {
      console.log(`Section Clicked: ${section}`);
      let selector = "." + section.toLowerCase()
              .replace(/_/g, "-")
              .replace(/,/g, "-")
              .replace(/\//g, "-")
          + "-group";
      console.log(`Selector: ${selector}`);
      let menuBlock = document.querySelector(selector);
      menuBlock.style.backgroundColor = "white";

    },
    unhighlightAllMenuItem: function (section) {
      let menuBlocks = document.querySelectorAll("li[class$='-group nav-item']");
      if (menuBlocks.length > 0) {
        menuBlocks.forEach(val => {
          val.style.backgroundColor = "transparent";
        });
      }

    },
    tabClick(tab, item) {
      if (this.$route.name === "Vineyard Page" || this.$route.name === "Vineyard Page Editor") {
        this.closeAllSubmenus();
        this.unhighlightAllMenuItem(tab);
        this.highlightMenuItem(this.topParent[0]);
        document.getElementById(this.toIdString(tab)).style.display = "inline";
        document.getElementById(this.toIdString(tab)).style.display = "inline";
        this.topParent.forEach(parent => {
          document.getElementById(this.toIdString(parent)).style.display = "initial";
          document.getElementById(this.toIdString(parent)).style.display = "inline";
        })
        Bus.$emit('vineyard-page-update', item.link);
      } else {
        //this.$router.push({name: "Vineyard Page", params: {thePageId: item.link}})
      }
    },
    /*    subMenuClick(item) {
          let newPage = item;
          console.log("TabHeader: Sub Menu Go to Page: " + newPage);
          Bus.$emit('page-update', newPa);
        },
        hasSubSection: function (sectionName) {
          let hasSubsection = (sectionName !== 'LEADERSHIP_AND_ENGAGEMENT') && (sectionName !== 'STORM_AND_WASTE_WATER');
          // TODO Remove this Console Log Statement
          console.log("Has Subsection: " + hasSubsection);
          return hasSubsection;
        },*/
    tabTitle(title) {
      return `${title}`;
    },
    getUlStyles: function () {
      let style = "padding-bottom: 10px; padding-top: 10px; list-style-type: none;";
      if (this.topLevelParent === this.sectionName) {
        style = style + "background-color: #f8f8f8;";
      }
      return style;
    },
    onEnd: function () {
      // Test
    },
    removeMe: function () {
      alert("remove me");
    },
    expand: function (id) {
      console.log("ul-first:", document.getElementById(this.toIdString(id)));
      let li_toggle = document.getElementById(id + "-li").style.display === "initial" ? "none" : "initial"
      let submenu_toggle = document.getElementById(id + "-subMenu").style.display === "initial" ? "none" : "initial"
      //document.getElementById(id+"-li").style.display = li_toggle;
      document.getElementById(id + "-subMenu").style.display = submenu_toggle;
      document.getElementById(id).style.display = "inline"
      this.topParent.forEach(parent => {
        document.getElementById(this.toIdString(parent)).style.display = "initial";
        document.getElementById(this.toIdString(parent)).style.display = "inline";
      })
      //this.highlightMenuItem(id);
    }
  }
}
</script>

<style>
.napa-green_vineyard-introduction {
  color: #28763a;
  font-size: 14px;
}

.environmental-compliance-group-d {
  color: #EC625F;
  font-size: 14px;
}

.leadership-and_sustainability_engagement {
  color: #8A1F03;
  font-size: 14px;
}

.certification-program_costs {
  font-size: 13px;
}

.social_equity_justice_and_inclusion-group {
  color: #c29d64;
  font-size: 14px;
}

.carbon-farm_plan_and_regenerative_agriculture {
  color: rgb(80, 92, 19);
  font-size: 14px;
}

.irrigation-assessments_and_water_efficiency {
  color: #1F497D;
  font-size: 14px;
}

.prohibited-and_restricted_pesticides_list {
  color: #851527;
  font-size: 14px;
}

.conservation-burning_and_burn_alternatives {
  color: #DE7728;
  font-size: 14px;
}

.tree-forest-preservation_and_enhancement {
  font-size: 14px;
  color: #A7AA61;
}

.social_equity_justice_and_inclusion-group {
  color: #c29d64;
  font-size: 14px;
}

.social-justice_diversity_and_inclusion {
  color: #c29d64;
  font-size: 14px;
}

.social-justice--diversity-and-inclusion-group {
  color: #c29d64;
  font-size: 14px;
}

.napa-green-vineyard-introduction-group {
}

.environmental-compliance-group-d {
}

.carbon-farm-plan-and-regenerative-agriculture-group {
}

.irrigation-assessments-and-water-efficiency-group {
}

.leadership_and_human_resources-group {
}

.workforce_health_safety_and_wellbeing-group {
}

.tree-forest-preservation-and-enhancement-group {
}

.treeforest_preservation_and_enhancement {
}

.proactive-planning_and_risk_prevention {
}

.vue-icon path[pid='0'] {
  fill: #42b983;
}

.vue-icon path[pid='1'] {
  fill: #35495e;
}

.leadership-and_engagement {
  color: #8A1F03;
  font-size: 14px;
}

.energy-efficiency {
  color: rgb(222, 119, 43);
  font-size: 14px;
}

.water-efficiency {
  color: rgb(156, 192, 184);
  font-size: 14px;
}

.waste-prevention_and_supply_chain {
  color: rgb(226, 201, 70);
  font-size: 14px;
}

.climate-action {
  color: rgb(167, 170, 97);
  font-size: 14px;
}

.equity-and_community {
  color: rgb(80, 92, 19);
  font-size: 14px;
}

.social-justice-diversity-and-inclusion {
  color: rgb(80, 92, 19);
  font-size: 14px;
}

.storm-and_waste_water {
  color: rgb(90, 117, 114);
  font-size: 14px;
}

.leadership_and_engagement_progress {
  background-color: #8A1F03;
}

.energy_efficiency_progress {
  background-color: rgb(222, 119, 43);
}

.water_efficiency_progress {
  background-color: rgb(156, 192, 184);
}

.waste_reduction_progress {
  background-color: rgb(226, 201, 70);
}

.pollution_prevention_progress {
  background-color: rgb(167, 170, 97);
}

.equity_and_community_progress {
  background-color: rgb(80, 92, 19);
  font-size: 14px;
}

.storm_and_waste_water_progress {
  background-color: rgb(90, 117, 114);
}

.leadership_and_engagement-line-item {
  color: #808080;
  padding-left: 40px;
  font-size: 13px;
}

.energy_efficiency-line-item {
  color: #808080;
  padding-left: 035px;
  font-size: 13px;
}

.water_efficiency-line-item {
  color: #808080;
  padding-left: 40px;
  font-size: 13px;
}

.vineyard_1-line-item {
  color: #808080;
  padding-left: 40px;
  font-size: 13px;
}


.vineyard_2-line-item {
  color: #808080;
  padding-left: 40px;
  font-size: 13px;
}

.waste_reduction-line-item {
  color: #808080;
  padding-left: 40px;
  font-size: 13px;
}

.pollution_prevention-line-item {
  color: #808080;
  padding-left: 40px;
  font-size: 13px;
}

.equity_and_community-line-item {
  color: #808080;
  padding-left: 40px;
  font-size: 13px;
}

.storm_and_waste_water-line-item {
  color: #808080;
  padding-left: 40px;
  font-size: 13px;
}


.default-line-item {
  /*color: #808080;*/
  padding-left: 50px;
  font-size: 13px;
}

/* recommended css code for vue-svgicon */
.svg-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  color: inherit;
  vertical-align: middle;
  fill: none;
  stroke: currentColor;
}

.svg-fill {
  fill: currentColor;
  stroke: none;
}

.svg-up {
  /* default */
  transform: rotate(0deg);
}

.svg-right {
  transform: rotate(90deg);
}

.svg-down {
  transform: rotate(180deg);
}

.svg-left {
  transform: rotate(-90deg);
}

.sub-menu {
  padding: 0px;
}

/* unvisited link */
a:link {
  text-decoration: none;
}

/* visited link */
a:visited {
  color: #808080;
}

/* mouse over link */
a:hover {
  color: #333333;
}

/* selected link */
a:active {
  color: #808080;
}

.handle {
  cursor: move;
  vertical-align: middle;
}
</style>
